"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerpModule = void 0;
const modules_1 = require("./modules");
const defaultOptions = {
    inverse: false,
    configuration: 's3',
};
class PerpModule {
    constructor(context, options) {
        this.context = context;
        const { inverse, configuration, basePath } = {
            ...defaultOptions,
            ...options,
        };
        this.config = new modules_1.ConfigModule(context);
        this.gate = new modules_1.GateModule(context);
        this._observer = new modules_1.ObserverModule(context);
        this.calc = inverse ? new modules_1.InverseCalcModule(context) : new modules_1.CalcModule(context);
        this.instrument = inverse ? new modules_1.InverseInstrumentModule(context) : new modules_1.InstrumentModule(context);
        this.observer = inverse ? new modules_1.InverseObserverModule(context) : new modules_1.ObserverModule(context);
        this.simulate = inverse ? new modules_1.InverseSimulateModule(context) : new modules_1.SimulateModule(context);
        this.configuration =
            configuration === 'local'
                ? new modules_1.LocalConfigurationModule(context)
                : new modules_1.S3ConfigurationModule(context, basePath);
    }
    registerQuoteInfo(tokenInfo) {
        this.context.tokenInfo.set(tokenInfo.symbol.toLowerCase(), tokenInfo);
        this.context.tokenInfo.set(tokenInfo.address.toLowerCase(), tokenInfo);
        this.context.registerAddress(tokenInfo.address, tokenInfo.symbol);
    }
}
exports.PerpModule = PerpModule;
